import IdCardFileView from './IdCardFileView'
export default IdCardFileView
